import { Swatch, TemplateKey, TemplateRule } from '../ts/types';
import materials, { getSwatch } from './materials';
import chikara from './materials/chikara';

const templateRules: TemplateRule[] = [
    {
        key: '90Three',
        className: 'no-hover no-click',
        variation: 'STD',
        panels: [
            {
                panelIds: [6, 14],
                swatch: getSwatch('icarexPc31', 31),
            },
            {
                panelIds: [0, 8, 3, 11],
                swatch: getSwatch('icarexPc31', 32),
            },
            {
                panelIds: [7, 15, 4, 12, 1, 9],
                swatch: getSwatch('icarexPc31', 33),
            },
        ],
        globalColorIds: [2, 5, 10, 13],
        forbiddenColors: [
            { material: 'icarexPc31', swatchIndices: [31, 32, 33] },
            { material: 'chikara', swatchIndices: [1, 7, 8] },
        ],
    },
    {
        key: '90Three',
        className: 'no-hover no-click',
        variation: 'SUL',
        panels: [
            {
                panelIds: [6, 14],
                swatch: getSwatch('icarexPc31', 31),
            },
            {
                panelIds: [0, 8],
                swatch: getSwatch('icarexPc31', 31),
            },
            {
                panelIds: [3, 11],
                swatch: getSwatch('icarexPc31', 32),
            },
            {
                panelIds: [7, 15, 4, 12, 1, 9],
                swatch: getSwatch('icarexPc31', 33),
            },
        ],
        globalColorIds: [2, 5, 10, 13],
        forbiddenColors: [
            { material: 'icarexPc31', swatchIndices: [31, 32, 33] },
            { material: 'chikara', swatchIndices: [1, 7, 8] },
        ],
    },
    {
        key: '90Three',
        className: 'no-hover no-click',
        variation: 'VTD',
        panels: [
            {
                panelIds: [6, 14],
                swatch: getSwatch('icarexPc31', 31),
            },
            {
                panelIds: [0, 8],
                swatch: getSwatch('icarexPc31', 34),
            },
            {
                panelIds: [3, 11],
                swatch: getSwatch('icarexPc31', 32),
            },
            {
                panelIds: [7, 15, 4, 12, 1, 9],
                swatch: getSwatch('icarexPc31', 33),
            },
        ],
        globalColorIds: [2, 5, 10, 13],
        forbiddenColors: [
            { material: 'icarexPc31', swatchIndices: [31, 32, 33] },
            { material: 'chikara', swatchIndices: [1, 7, 8] },
        ],
    },
    {
        key: '90Three',
        className: 'no-hover no-click',
        variation: 'NOTHING',
        panels: [
            {
                panelIds: [6, 14, 0, 8, 3, 11, 7, 15, 4, 12, 1, 9],
                swatch: getSwatch('icarexPc31', 31),
            },
        ],
        globalColorIds: [2, 5, 10, 13],
        forbiddenColors: [
            { material: 'icarexPc31', swatchIndices: [31, 32, 33] },
            { material: 'chikara', swatchIndices: [1, 7, 8] },
        ],
    },
];

// template rule utilities
export const templateRuleIds = templateRules.map((rule) => rule.key);
export const getTemplateRule: (
    key: TemplateKey,
    variation: null | string
) => TemplateRule = (key, variation) =>
    templateRules.find((rule) =>
        variation
            ? rule.key === key && rule.variation === variation
            : rule.key === key
    );

export const isSwatchForbiddden = (
    template: TemplateKey,
    swatch: Swatch
): boolean => {
    const templateRule = getTemplateRule(template, null);

    return templateRule
        ? getTemplateRule(template, null).forbiddenColors.reduce(
              (forbidden, rule) => {
                  return (
                      (rule.material === swatch.material &&
                          rule.swatchIndices.includes(swatch.index)) ||
                      forbidden
                  );
              },
              false
          )
        : false;
};

export default templateRules;
